import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ToastrService } from 'ngx-toastr';
import { ElectronService } from '../../services/electron.service';
import { ApisService } from '../../services/apis.service';

@Component({
  selector: 'app-race-comments',
  templateUrl: './race-comments.component.html',
  styleUrls: ['./race-comments.component.scss']
})
export class RaceCommentsComponent implements OnInit {

  @Input() race;
  meta: {
    saving: boolean
  };
  userId: number;
  raceComment: string;

  constructor(
    public activeModal: NgbActiveModal,
    private apiService: ApisService,
    private notification: ToastrService
  ) { }

  ngOnInit() {
    this.meta = {
      saving: false
    }
    this.raceComment = this.race.comment || '';

    this.apiService.observableLoggedIn.subscribe(data => {
      this.userId = data.user_id;
    });
  }

  confirm() {
    this.meta.saving = true;
    let payload = {
      raceId: this.race.raceId,
      yearOfRace:this.race.yearOfRace,
      divisionSequence:this.race.divisionSequence,
      comment: this.raceComment,
      updatedBy: this.userId
    };

    this.apiService.updateRace(payload.yearOfRace, payload.raceId, payload.divisionSequence, payload)
      .subscribe(
        res => {
          // console.log('[ DEBUG ] Race Data Saved:', res);
          this.activeModal.close(res);
          this.notification.success(`${this.race.raceName} comments has been saved.`, 'Race Comment');
        },
        err => {
          console.error('[ DEBUG ] Error updating Race', err);
          this.notification.error(`Could't save the notes. Check your connection and Try again.`, 'Race Comment');
          this.meta.saving = false;
        }
      );
  }

  cancel(action) {
    this.activeModal.dismiss(action);
  }

}
